export enum SystemRole {
    All = 'all',
    Developer = 'Developer',
    SystemAdmin = 'SystemAdmin',
    // Add more roles here.
    DistrictAdmin = 'DistrictAdmin',
    AAEAdmin = 'AAEAdmin',
    PrincipalUpdater = 'Updater',
    Board = 'Board',
    Regional = 'Regional',
    Principal = 'Principal',
}
